// Keep external destinations in a separate tab, including menus loaded later.
const selector = 'a[href]';
function updateLink(link) {
  const url = new URL(link.getAttribute('href'), document.baseURI);
  if (!['http:', 'https:'].includes(url.protocol) || url.hostname === location.hostname) return;
  if (link.target !== '_blank') link.target = '_blank';
  if (!link.relList.contains('noopener')) link.relList.add('noopener');
  if (!link.relList.contains('noreferrer')) link.relList.add('noreferrer');
}
function updateTree(root) {
  if (root instanceof HTMLAnchorElement) updateLink(root);
  root.querySelectorAll?.(selector).forEach(updateLink);
}
updateTree(document);
new MutationObserver((records) => {
  for (const record of records) {
    if (record.type === 'attributes') updateTree(record.target);
    else record.addedNodes.forEach(updateTree);
  }
}).observe(document.documentElement, {childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'target', 'rel']});
